import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { ACTION_BACK_PATH, HISTO_CYTO_RPORTS_DETAILS_PATH, HISTO_CYTO_RPORTS_PATH } from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const HistoCytoPage = lazy(() => import('@features/HealthRecords/TestReports/HistoCyto/pages/HistoCytoPage'));
const HistoCytoDetailsPage = lazy(
  () => import('@features/HealthRecords/TestReports/HistoCyto/pages/HistoCytoDetailsPage')
);

export const HISTO_CYTO_REPORTS_ROUTES: RouteConfig[] = [
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <HistoCytoPage />,
    displayTitle: () => 'Histology & Cytology Reports',
    pageType: PageType.PRIVATE,
    path: HISTO_CYTO_RPORTS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.histologyAndCytologyReports,
    actionUrl: ACTION_BACK_PATH,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <HistoCytoDetailsPage />,
    displayTitle: () => 'Histology & Cytology Report Details',
    pageType: PageType.PRIVATE,
    path: HISTO_CYTO_RPORTS_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.histologyAndCytologyReports,
  },
];
